/* unplugin-vue-components disabled */import script from "./RewardRedeemList.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardRedeemList.vue?vue&type=script&setup=true&lang=js"

import "./RewardRedeemList.vue?vue&type=style&index=0&id=2733a592&lang=scss"

const __exports__ = script;

export default __exports__